import React, { useState, useContext, useEffect } from "react";
import "./MembershipBooking.css";
import { StateContext } from "../../../../StateProvider";
import NeedHelp from "../../../../Utilities/components/NeedHelp";
import Footer from "../../../../Footer";

function MembershipBooking() {
  const context = useContext(StateContext);
  const setBookingData = context.setBookingData;
  const today = new Date();

  const [membershipBookingData, setMembershipBookingData] = useState({
    selectedPackage: "",
    dateRange: [today],
  });

  // Update bookingData in global state when membership selection changes
  useEffect(function () {
    setBookingData(function (prev) {
      var updated = Object.assign({}, prev);
      updated.bookingType = "store/membership";
      updated.bookingInfo = membershipBookingData;
      return updated;
    });
  }, [membershipBookingData]);

  // Handle membership plan selection
  function handlePackageSelect(key) {
    setMembershipBookingData(function (prev) {
      var isSame = prev.selectedPackage === key;
      var updated = Object.assign({}, prev);
      updated.selectedPackage = isSame ? "" : key;
      return updated;
    });
  }

  var selected = membershipBookingData.selectedPackage;

  // Define membership plans
  var plans = [
    {
      key: "Club",
      label: "Pawsible Club",
      color: "#4CA7DF",
      price: 99,
      benefits: {
        discount: "10%",
        concierge: "✓",
        feeding: "✓",
        health: "✓",
        report: "✓",
        events: "✓",
        booking: "—",
        birthday: "—",
        bonus: "—",
      },
    },
    {
      key: "Plus",
      label: "Pawsible Plus Club",
      color: "#FFB516",
      price: 149,
      benefits: {
        discount: "20%",
        concierge: "✓",
        feeding: "✓",
        health: "✓",
        report: "✓",
        events: "✓",
        booking: "✓",
        birthday: "✓",
        bonus: "✓",
      },
    },
  ];

  // Define membership benefits labels
  var benefitLabels = [
    { id: "discount", text: "Member Savings" },
    { id: "concierge", text: "Concierge & Text Support" },
    { id: "feeding", text: "Premium Daily Feeding" },
    { id: "health", text: "Health & Grooming Check" },
    { id: "report", text: "Daycare Report Card" },
    { id: "events", text: "Exclusive Member Events" },
    { id: "booking", text: "Top-Priority Booking" },
    { id: "birthday", text: "Birthday Gift" },
    { id: "bonus", text: "Nail Trim & Teeth Brushing" },
  ];

  return (
    <div>
      <div className="membership-container">
        <div className="membership-header">
          <h2>Membership</h2>
          <p>Choose what fits your pet’s lifestyle best.</p>
        </div>

        <div className="membership-chart">
          <div className="chart-header">
            <span className="benefit-label"></span>

            {plans.map(function (plan, i) {
              var isSelected = selected === plan.key;
              var selectedClass = isSelected
                ? "chart-col selected"
                : "chart-col";

              return (
                <div
                  key={i}
                  className={selectedClass}
                  onClick={function () {
                    handlePackageSelect(plan.key);
                  }}
                >
                  <h3 style={{ color: plan.color }}>{plan.label}</h3>
                  <div className="chart-price">${plan.price} / mo</div>
                </div>
              );
            })}
          </div>

          <ul className="benefit-matrix">
            {benefitLabels.map(function (row, idx) {
              return (
                <li key={idx} className="benefit-row">
                  <span className="benefit-text">{row.text}</span>

                  {plans.map(function (plan, j) {
                    var val = plan.benefits[row.id];
                    var show = val === "✓" ? "✓" : val || "—";
                    var colorClass = "";

                    if (row.id === "discount") {
                      if (val === "10%") colorClass = "discount-low";
                      else if (val === "20%") colorClass = "discount-high";
                    } else {
                      colorClass =
                        plan.key === "Club" ? "tier-club" : "tier-plus";
                    }

                    var classes = "benefit-val ";
                    if (show === "✓" || row.id === "discount") {
                      classes += colorClass;
                    } else {
                      classes += "tier-empty";
                    }

                    return (
                      <span key={j} className={classes}>
                        {show}
                      </span>
                    );
                  })}
                </li>
              );
            })}
          </ul>
        </div>
      </div>

      {/* Help section with background image */}
      <div className="sign-up-section">
        <NeedHelp />
      </div>

      <Footer />
    </div>
  );
}

export default MembershipBooking;
